import Rx from 'rxjs';
import { push } from 'react-router-redux';
import { combineEpics } from 'redux-observable';
import { change } from 'redux-form/immutable';

import * as constAction from 'root/actionConstants';
import * as trayectosActions from 'modules/trayectos/action';
import * as generalActions from 'modules/general/action';
import * as errorActions from 'modules/error/action';
import { request } from 'core/generalFunctions';
import { FORM_TRAYECTO } from 'modules/forms/formConstants';

const { ajax } = Rx.Observable;

export const getEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_GET)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response }) => trayectosActions.setState({ lista: response }))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getFullEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_GETFULL)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response }) => trayectosActions.setState({ trayecto: response }))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const setEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_SET)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .mergeMap(() => [push('/dashboard/trayectos/'), generalActions.snackbar_show('Trayecto guardado')])
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const previewEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_PREVIEW)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response: { trayecto } }) => change(FORM_TRAYECTO, 'polyline', trayecto))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const findEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_FIND_PARADA)
    .debounceTime(500)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response }) =>
          trayectosActions.setState({
            [action.parameters.reducerName]: response.map(
              (p) => p._paradas && Object.assign(p._paradas, { fullName: p._paradas.alias ? p._paradas.alias.concat(` (${p._paradas.nombre})`) : p._paradas.nombre }),
            ),
          }),
        )
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getParadasEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_GET_PARADAS)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response }) => {
          let names = {};
          if (Array.isArray(action.parameters.reducerName)) {
            for (let itm in action.parameters.reducerName) {
              names[action.parameters.reducerName[itm]] = response.map((p) =>
                Object.assign(p._paradas, {
                  fullName: p._paradas.alias ? p._paradas.alias.concat(` (${p._paradas.nombre})`) : p._paradas.nombre,
                }),
              );
            }
          } else
            names = {
              [action.parameters.reducerName || 'paradas']: response.map((p) =>
                Object.assign(p._paradas, {
                  fullName: p._paradas.alias ? p._paradas.alias.concat(`(${p._paradas.nombre})`) : p._paradas.nombre,
                }),
              ),
            };
          return trayectosActions.setState(names);
        })
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const getParadasUserEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_GET_PARADAS_USER)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .switchMap(({ response }) => {
          if (!response) return Rx.Observable.empty();
          let paradasSalida = [],
            paradasDestino = [],
            stateParadas = {};

          if (response && response.paradas) {
            paradasSalida = response.paradaSubida && response.paradaSubida.map && response.paradaSubida.map((paradaId) => response.paradas.find((p) => p.paradaId == paradaId));
            paradasDestino = response.paradaBajada && response.paradaBajada.map && response.paradaBajada.map((paradaId) => response.paradas.find((p) => p.paradaId == paradaId));
          }
          paradasSalida = paradasSalida.filter(Boolean);
          paradasDestino = paradasDestino.filter(Boolean);
          if (paradasSalida.length > 0) {
            stateParadas[action.parameters.reducerName + 'paradaSubida'] = paradasSalida.map(
              (p) =>
                p._paradas &&
                Object.assign(p._paradas, {
                  fullName: p._paradas.alias ? p._paradas.alias.concat(`(${p._paradas.nombre})`) : p._paradas.nombre,
                }),
            );
          }
          if (paradasDestino.length > 0)
            stateParadas[action.parameters.reducerName + 'paradaBajada'] = paradasDestino.map(
              (p) =>
                p._paradas &&
                Object.assign(p._paradas, {
                  fullName: p._paradas.alias ? p._paradas.alias.concat(`(${p._paradas.nombre})`) : p._paradas.nombre,
                }),
            );
          return Rx.Observable.of(trayectosActions.setState(stateParadas));
        })
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const deleteEpic = (action$, store) =>
  action$.ofType(constAction.TRAYECTOS_DELETE).switchMap((action) =>
    ajax(request(action))
      .mergeMap(() => [generalActions.snackbar_show('Trayecto eliminado'), trayectosActions.delState(action.payload.trayectoId)])
      .catch((err) => {
        if (err && err.response && err.response.error && err.response.error.name == 'TRAYECTO_CON_RUTINAS') return Rx.Observable.of(generalActions.snackbar_show(err.response.error.message));
        return errorActions.request(err, action);
      })
      .startWith(generalActions.loadingbar_show())
      .finally(() => store.dispatch(generalActions.loadingbar_hide())),
  );

export const getTasksEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_GET_TASKS)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(({ response }) => trayectosActions.setState({ tasks: response }))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export const taskPhotoEpic = (action$, store) =>
  action$
    .ofType(constAction.TRAYECTOS_PHOTOS_TASK)
    .debounceTime(1000)
    .switchMap((action) =>
      ajax(request(action))
        .map(() => trayectosActions.getTasks(action.payload.trayectoId, 'takePhoto'))
        .catch((err) => errorActions.request(err, action))
        .startWith(generalActions.loadingbar_show())
        .finally(() => store.dispatch(generalActions.loadingbar_hide())),
    );

export default combineEpics(getEpic, setEpic, previewEpic, getFullEpic, deleteEpic, findEpic, getParadasEpic, getParadasUserEpic, getTasksEpic, taskPhotoEpic);



// WEBPACK FOOTER //
// src/modules/trayectos/epics.js